export function isRouteTargetMatch(route, target) {
  if (!target) return false

  const currentPath = String(route?.path || '')
  const currentName = String(route?.name || '')
  const targetPath = String(target.path || '')
  const targetName = String(target.name || '')

  if (targetName && currentName === targetName) return true

  if (!targetPath) return false
  if (targetPath === '/') return currentPath === '/'
  return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`)
}

export function resolveNavTarget(item) {
  if (!item || typeof item !== 'object') return null
  return normalizeToTarget(item?.props?.to) || normalizeToTarget(item?.to)
}

export function validateNavOptions(options) {
  const issues = []
  const items = Array.isArray(options) ? options : []

  function pushIssue(item, reason) {
    issues.push({
      reason,
      title: String(item?.title || ''),
      value: String(item?.value || ''),
    })
  }

  function validateItem(item, context) {
    if (!item || typeof item !== 'object') {
      issues.push({ reason: `${context}: invalid item`, title: '', value: '' })
      return
    }

    const type = String(item.type || '')
    if (type === 'divider' || type === 'subheader') return

    if (!String(item.value || '').trim()) {
      pushIssue(item, `${context}: missing value`)
    }

    const children = item.children
    const hasChildren = Array.isArray(children) && children.length > 0

    if (children != null && !Array.isArray(children)) {
      pushIssue(item, `${context}: children must be an array`)
      return
    }

    if (hasChildren) {
      for (const child of children) {
        validateItem(child, `${context} > child`)
      }
      return
    }

    if (!resolveNavTarget(item)) {
      pushIssue(item, `${context}: missing or invalid route target`)
    }
  }

  for (const item of items) {
    validateItem(item, 'side-nav')
  }

  return issues
}

function normalizeToTarget(to) {
  if (!to) return null

  if (typeof to === 'string') {
    const path = to.trim()
    return path ? { name: '', path } : null
  }

  if (typeof to !== 'object') return null

  const path = typeof to.path === 'string' ? to.path.trim() : ''
  const name = typeof to.name === 'string' ? to.name.trim() : ''
  if (!path && !name) return null

  return { name, path }
}
